import { FETCH_APPOINTMENTS } from "../../actions/types";

const initialState = {
  appointments: []
};

export default function(state = initialState, action) {
  switch (action.type) {
    case FETCH_APPOINTMENTS:
      return {
        ...state,
        appointments: action.payload
      };

    default:
      return state;
  }
}
